import _find from 'lodash/find';

export const getAuthedUser = state => state.environment.user;
export const getBooking = (state, staticUId) => state.entities.bookings[staticUId];
export const getBookingByVersionedUId = (state, versionedUId) => _find(state.entities.bookings, b => b.versionedUId === versionedUId);
export const getCurrentAvailabilityWindow = (state, staticUId) => state.entities.currentAvailabilityWindows[staticUId];

export const getNewBooking = (state) => state.newBooking;



// WEBPACK FOOTER //
// ./scripts/selectors/index.js